import { type Session, type User, type UserAppMetadata } from "@supabase/supabase-js";

import { type UserRoleEnum } from "@fitness-app/data-models";

import { getLoggedUser } from "../../../helpers/getLoggedUser";
import { normalizeCustomClaims } from "../../../helpers/normalizeCustomClaims";
import { type AppThunk } from "../../../index";
import { logInSuccess } from "../reducer";
import { UserStatus } from "../types";
import { subscribeToUserProfile } from "./subscribeToUserProfile";

export const setLoggedUserData =
  (
    { id, email }: User,
    session?: Session | null,
    isMobile = false,
    claims?: UserAppMetadata,
    identify = false,
  ): AppThunk =>
  async (dispatch, getState, { auth, analytics }) => {
    const { status } = getState().user;

    if (status === UserStatus.LOGGING_IN) {
      return;
    }

    const rawCustomClaims = claims ?? session?.user.app_metadata ?? (await getLoggedUser(auth)).customClaims;
    const customClaims = normalizeCustomClaims(rawCustomClaims);

    dispatch(
      logInSuccess({
        id,
        email,
        customClaims: customClaims || null,
      }),
    );

    if (identify) {
      analytics.identify(id, {
        email,
        role: customClaims?.role as UserRoleEnum,
      });
    }

    dispatch(subscribeToUserProfile(id, isMobile));
  };
